import { httpClient } from './http';
import { API_ENDPOINTS } from '../config/api';

export type Reservation = {
  id: string;
  restaurant_id: string;
  table_id: string;
  user_id: string;
  reservation_date: string;
  party_size: number;
  status: 'pending' | 'confirmed' | 'cancelled' | 'completed' | 'no_show';
  selection_id?: string | null;
  metadata?: any;
};

export const reservationsService = {
  list: async (userId: string, restaurantId: string): Promise<Reservation[]> => {
    const res = await httpClient.get<Reservation[]>(API_ENDPOINTS.RESERVATIONS(userId, restaurantId), undefined, 'authenticated');
    return res as any;
  },

  updateStatus: async (userId: string, restaurantId: string, reservationId: string, status: Reservation['status']): Promise<Reservation> => {
    const res = await httpClient.put<Reservation>(API_ENDPOINTS.RESERVATION_STATUS(userId, restaurantId, reservationId), { status }, 'authenticated');
    return res as any;
  },
};


